<template>
  <div class="animated fadeIn">
    <div class="col-sm-12 col-md-12">
      <div id="dados-formulario-tab" class="card">
        <div class="card-body">
          <div id="titulo">
            <div class="row">
              <div class="col-sm-12 col-md-12">
                <h4>Editar Ponto</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-12 pull-right">
                <input id="botaoSalvar" class="btn btn-success" type="submit" value="Salvar" v-on:click="salvar">
                <router-link id="btnNovoVeiculo" class="btn btn-warning" to="/pontos">
                  <span class="glyphicon glyphicon-back"></span> Fechar
                </router-link>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-sm-12 col-md-12">
              <div class="tabbable">
                <!-- Only required for left/right tabs -->
                <ul class="nav nav-tabs">
                  <li class="nav-item active"><a href="#tab1" data-toggle="tab" class="nav-link active">Geral</a></li>
                </ul>

                <div class="tab-content">
                  <div class="tab-pane active" id="tab1">
                    <div class="dados_form">
                      <div class="col-sm-12 col-md-12">
                        <input type="hidden" v-model="model.id" />
                        <div class="row">
                          <div class="form-group col-sm-2 col-md-2">
                            <label class="control-label">Código:</label><br>
                            <input class="pula form-control placa" v-model="model.codigo" />
                          </div>
                          <div class="form-group col-sm-8 col-md-8">
                            <label class="control-label">Descrição:</label><br>
                            <input class="pula form-control" v-model="model.descricao"
                              required="required" />
                          </div>
                          
                          <div class="form-group col-sm-2 col-md-2">
                            <label>Tipo Ponto:</label><br>
                            <select class="pula form-control" v-model="model.pontoTipoId">
                              <option value="false" label="Não" />
                              <option value="true" label="Sim" />
                            </select>
                          </div>
                        </div>

                        <div class="row">
                          <div class="form-group col-sm-12 col-md-12">
                            <label>Cliente:</label><br>
                            <input type="hidden" id="clienteId" v-model="model.clienteId" />
                            <buscar-cliente  v-validate="'required'" id="clienteNome" name="clienteNome" :classes="{ input: 'input pula form-control', wrapper: 'input-wrapper'}" :required="true" :errors="errors.has('clienteNome')" v-model="model.clienteNomeFantasia" :on-select="setarCliente" :on-blur="verificarCliente"/>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      model: {
        id: '0',
        ativo: false,
        codigo: '',
        descricao: '',
        clienteId: '0',
        clienteNome: '',
        clienteNomeFantasia: '',
        pontoTipoId: '0',
        pontoTipoDescricao: '',
        latitude: '0',
        longitude: '0'
      },
      pontosTipos: []
    }
  },
  created: function () {
    this.buscar()
    this.buscarPontosTipos()
  },
  mounted: function () {
    $('.pula').keypress(function (e) {
      var tecla = (e.keyCode ? e.keyCode : e.which)
      if (tecla === 13) {
        let campo = $('.pula')
        let indice = campo.index(this)
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus()
        }
        if (campo[indice + 1] != null) {
          let proximo = campo[indice + 1]
          proximo.focus()
        }
        e.preventDefault(e)
        return false
      }
    })
  },
  methods: {
    buscar: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/pontos/' + this.$route.params.id
      axios.get(url, config)
      .then(function (response) {
        var dados = response.data
        self.model.id = dados.id
        self.model.ativo = dados.ativo
        self.model.codigo = dados.codigo
        self.model.descricao = dados.descricao
        self.model.clienteId = dados.clienteId
        self.model.clienteNome = dados.clienteNome
        self.model.clienteNomeFantasia = dados.clienteNomeFantasia
        self.model.pontoTipoId = dados.pontoTipoId
        self.model.pontoTipoDescricao = dados.pontoTipoDescricao
        self.model.latitude = dados.latitude
        self.model.longitude = dados.longitude
      })
    },
    buscarPontosTipos: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/pontosTipos/buscarPontosTiposAtivos?busca='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.pontosTipos = dados
      })
    },
    setarCliente: function (cliente) {
      this.model.clienteId = cliente.id
      this.model.clienteNomeFantasia = cliente.nomeFantasia
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia)
    },
    verificarCliente: function () {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
    },
    salvar: function () {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          console.log(JSON.stringify(self.model))
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$store.state.token
            }
          }
          var url = '/api/pontos/salvar'
          axios.post(url, JSON.stringify(self.model), config)
          .then(function (response) {
            console.log(response)
            if (response.data === 'OK') {
              self.$toastr('success', 'Ponto gravado com sucesso.', 'Atenção')
              self.$router.replace('/pontos')
            }
          })
          .catch(function (error) {
            console.log(error)
          })
        } else {
          this.$toastr('error', 'Complete os campos destacados.', 'Atenção')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/pontos/PontosEditar.vue